var map = {
	"./Add_light.svg": "5d44",
	"./Arrow_bottom_alt.svg": "b465",
	"./Arrow_top_alt.svg": "74f3",
	"./Desk_alt.svg": "31af",
	"./Done_all_round.svg": "6d60",
	"./Edit_light.svg": "84ea",
	"./Expand_left_double_light.svg": "054f",
	"./Expand_left_light.svg": "2e68",
	"./Expand_right_double_light.svg": "9a3d",
	"./Expand_right_light.svg": "88ab",
	"./Filter.svg": "4d96",
	"./Hanger.svg": "7216",
	"./Hide.svg": "6361",
	"./Img_box_duotone_line.svg": "60cb",
	"./Notebook.svg": "e514",
	"./Order.svg": "fe27",
	"./Panel.svg": "4f13",
	"./Shop_light.svg": "824d",
	"./Sign_out_squre.svg": "e7db",
	"./User_circle.svg": "a2c1",
	"./Vertical_switch_light.svg": "fd70",
	"./View.svg": "86fc",
	"./View_hide.svg": "c4ff",
	"./Wallet_alt.svg": "d577",
	"./Waterfall.svg": "23f1",
	"./check.svg": "a7c0",
	"./chevron-down.svg": "ee76",
	"./chevron-left.svg": "7fc6",
	"./chevron-right.svg": "c5d1",
	"./close.svg": "864a",
	"./comment_light.svg": "57e6",
	"./copy.svg": "c0a5",
	"./export.svg": "8354",
	"./lock.svg": "a012",
	"./options-vertical.svg": "ad93",
	"./save.svg": "b7b8",
	"./slider-left.svg": "e697",
	"./slider-right.svg": "0617",
	"./table.svg": "dc78",
	"./zipper.svg": "5602"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f853";